import { useState } from "react";
import { Area, AreaChart, CartesianGrid, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { MARKET_LABEL } from "./valueFormat";

const label = (d) => (d ? new Date(`${d}T12:00:00Z`).toLocaleDateString("en-GB", { day: "2-digit", month: "short" }) : "Start");

function Tip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return (
    <div className="vs-tip">
      <b>{label(p.day)}</b>
      <span>Bankroll {p.bankroll.toFixed(2)}</span>
      {p.day && <span className={p.profit >= 0 ? "is-up" : "is-down"}>{p.profit >= 0 ? "+" : ""}{p.profit.toFixed(2)} · {p.picks} picks</span>}
    </div>
  );
}

export function BankrollChart({ curves }) {
  const [market, setMarket] = useState("all");
  const points = curves?.[market] || curves?.all;
  if (!points?.length) return null;
  const start = points[0].bankroll;
  const end = points[points.length - 1].bankroll;
  const growth = start ? (end / start - 1) * 100 : 0;
  return (
    <div className="vs-chart" data-testid="value-bankroll-chart">
      <div className="vs-chart-head">
        <span>Bankroll following Kelly stakes{market !== "all" ? ` · ${MARKET_LABEL[market]} only` : ""}</span>
        <b className={growth > 0 ? "is-up" : growth < 0 ? "is-down" : ""} data-testid="value-bankroll-end">
          {end.toFixed(2)} <small>({growth >= 0 ? "+" : ""}{growth.toFixed(1)}%)</small>
        </b>
      </div>
      <div className="tv-pills vs-tabs">
        {Object.keys(curves).map((k) => (
          <button key={k} type="button" className={market === k ? "is-active" : ""} onClick={() => setMarket(k)} data-testid={`value-curve-${k}`}>
            {k === "all" ? "All markets" : MARKET_LABEL[k] || k}
          </button>
        ))}
      </div>
      {points.length < 2 ? <p className="tv-empty">The chart starts once the first value picks are settled.</p> : (
        <ResponsiveContainer width="100%" height={180}>
          <AreaChart data={points.map((p) => ({ ...p, x: label(p.day) }))} margin={{ top: 8, right: 8, left: -12, bottom: 0 }}>
            <defs>
              <linearGradient id="vsBank" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#3aafff" stopOpacity={0.45} />
                <stop offset="100%" stopColor="#3aafff" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="#12406f" strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="x" tick={{ fill: "#7f9cc0", fontSize: 11 }} stroke="#12406f" />
            <YAxis tick={{ fill: "#7f9cc0", fontSize: 11 }} stroke="#12406f" domain={["auto", "auto"]} />
            <ReferenceLine y={start} stroke="#ffd166" strokeDasharray="4 4" />
            <Tooltip content={<Tip />} />
            <Area type="monotone" dataKey="bankroll" stroke="#3aafff" strokeWidth={2} fill="url(#vsBank)" dot={{ r: 3, fill: "#3aafff" }} />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
